import React from "react";

interface AniTrackableWidgetProps {
  id: string;
  type: "chart" | "table" | "metric" | "document" | "form" | "list" | "map" | "timeline" | string;
  name: string;
  data?: Record<string, unknown>;
  children: React.ReactNode;
  className?: string;
  as?: React.ElementType;
}

/**
 * Wrapper component that makes a widget trackable by ANI chat.
 * 
 * ANI will be aware of this widget when it's visible in the viewport
 * and can reference it in conversations.
 * 
 * @example
 * ```tsx
 * <AniTrackableWidget
 *   id="performance-chart"
 *   type="chart"
 *   name="Performance Chart"
 *   data={{ timeframe: "1Y", benchmark: "S&P 500" }}
 * >
 *   <PerformanceChart />
 * </AniTrackableWidget>
 * ```
 */
export function AniTrackableWidget({
  id,
  type,
  name,
  data,
  children,
  className,
  as: Component = "div",
}: AniTrackableWidgetProps) {
  return (
    <Component
      data-ani-widget="true"
      data-ani-widget-id={id}
      data-ani-widget-type={type}
      data-ani-widget-name={name}
      data-ani-widget-data={data ? JSON.stringify(data) : undefined}
      className={className}
    >
      {children}
    </Component>
  );
}
